export class InstanceLoader<T> {
	constructor(private context: Object) {}

	getInstance(name: string, ...args: any[]): T {
		return <T>new this.context[name](...args);
	}
}
